import { Component, OnInit, Inject } from '@angular/core';
import { SIDE_EFFECT_DATA_TOKEN, SideEffectData } from '../models/types';
import { Rule } from "../../../../../common/models/flow.dto";

@Component({
    selector: 'app-side-effect-generate-well-api',
    templateUrl: './side-effect-generate-well-api.component.html',
    styleUrls: ['./side-effect-generate-well-api.component.scss'],
    standalone: false
})
export class SideEffectGenerateWellApiComponent {
    config: GenerateWellApiConfig;

    stateRule: Rule;
    countyRule: Rule;
    seqCodeRule: Rule;  
    sideTrackRule: Rule;
    uniqueWellIdentifierRule: Rule;  


    constructor(
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        this.config = data.configuration ? data.configuration : {
            stateCodePath: "", countyPath: "", uniqueWellIdentifierPath: "",
            sideTrackPath: "", seqCodePath: "", saveLocationPath: ""
        };

        this.stateRule = { ruleId: "", name: "", expression: this.config.stateCodePath };
        this.countyRule = { ruleId: "", name: "", expression: this.config.countyPath };
        this.uniqueWellIdentifierRule = { ruleId: "", name: "", expression: this.config.uniqueWellIdentifierPath }
        this.sideTrackRule = { ruleId: "", name: "", expression: this.config.sideTrackPath }
        this.seqCodeRule = { ruleId: "", name: "", expression: this.config.seqCodePath };
    }

    ruleCompiled(rule: Rule, ruleType: string) {
        switch (ruleType) {
            case "state":                
                this.stateRule = rule;
                this.config.stateCodePath = rule.expression;
                break;
            case "county":                
                this.countyRule = rule;
                this.config.countyPath = rule.expression;
                break;
            case "uniqueWellIdentifier":
                this.uniqueWellIdentifierRule = rule;
                this.config.uniqueWellIdentifierPath = rule.expression;
                break;
            case "sideTrack":
                this.sideTrackRule = rule;
                this.config.sideTrackPath = rule.expression;
                break;
            case "sequenceCode":                
                this.seqCodeRule = rule;
                this.config.seqCodePath = rule.expression;
                break;
        }
    }
}

type GenerateWellApiConfig = {
    stateCodePath: string;
    countyPath: string;
    uniqueWellIdentifierPath: string;
    sideTrackPath: string;
    seqCodePath: string;
    saveLocationPath: string;
}
